module.exports = __webpack_public_path__ + "media/packs/images/flags/MT-378b8a42107dd0d7fa7492740cfe714f.png";